import { render } from "./View.pug?vue&type=template&id=e2e90a52&ts=true&lang=pug&external"
import script from "./View.ts?vue&type=script&lang=ts&external"
export * from "./View.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contacts/View.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e2e90a52"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e2e90a52', __exports__)) {
    api.reload('e2e90a52', __exports__)
  }
  
  module.hot.accept("./View.pug?vue&type=template&id=e2e90a52&ts=true&lang=pug&external", () => {
    api.rerender('e2e90a52', render)
  })

}


export default __exports__